import * as api from '../../api';
import { getIsFetching } from '../reducers/zone';

export const FETCH_AAST_ZONE = 'zone.FETCH_AAST_ZONE';
export const FETCH_AAST_ZONE_SUCCESS = 'zone.FETCH_AAST_ZONE_SUCCESS';

const requestZone = () => ({
  type: FETCH_AAST_ZONE,
});

const receiveZone = ({ zone, points, comments }) => ({
  type: FETCH_AAST_ZONE_SUCCESS,
  zone,
  points: points.concat(comments),
});

export const fetchZone = id => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestZone());

  // Request interventions fetching then planning
  return api.getZoneById(id).then(response => dispatch(receiveZone(response)));
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/actions/zone.js